import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Label } from "reactstrap";
import axios from "axios";

import { withTranslation } from "react-i18next";

const SecurityLevelPassword = (props) => {
  const { t, lenght, password, username } = props;
  const [security, setSecurity] = useState([]);

  useEffect(() => {
    load();
    return () => {};
  }, [props.username, props.password]);

  const load = async () => {
    const user = {
      user: username,
      password: password,
    };
    if (username && password) {
      try {
        const res = await axios({
          url: "api/user/test-password",
          method: "POST",
          data: JSON.stringify(user),
        });
        setSecurity(res.data);
      } catch (err) {
        console.error(err);
      }
    }
  };
  if (!lenght || lenght === 0) {
    return <div />;
  } else if (security.passwordLevelDesc === "plVERYWEAK") {
    return (
      <div>
        <Label style={{ color: "#f86c6b" }}>
          {t("SecurityLevelPassword.veryWeak")}
        </Label>
      </div>
    );
  } else if (security.passwordLevelDesc === "plWEAK") {
    return (
      <div>
        <Label style={{ color: "#f86c6b" }}>
          {t("SecurityLevelPassword.weak")}
        </Label>
      </div>
    );
  } else if (security.passwordLevelDesc === "plAVERAGE") {
    return (
      <div>
        <Label style={{ color: "#ffc107" }}>
          {t("SecurityLevelPassword.average")}
        </Label>
      </div>
    );
  } else if (security.passwordLevelDesc === "plSTRONG") {
    return (
      <div>
        <Label style={{ color: "#17a2b8" }}>
          {t("SecurityLevelPassword.strong")}
        </Label>
      </div>
    );
  } else if (security.passwordLevelDesc === "plVERYSTRONG") {
    return (
      <div>
        <Label style={{ color: "#17a2b8" }}>
          {t("SecurityLevelPassword.veryStrong")}
        </Label>
      </div>
    );
  } else if (security.passwordLevelDesc === "plSECURE") {
    return (
      <div>
        <Label style={{ color: "#20c997" }}>
          {t("SecurityLevelPassword.secure")}
        </Label>
      </div>
    );
  } else if (security.passwordLevelDesc === "plVERYSECURE") {
    return (
      <div>
        <Label style={{ color: "#4dbd74" }}>
          {t("SecurityLevelPassword.verySecure")}
        </Label>
      </div>
    );
  } else {
    return <div />;
  }
};

SecurityLevelPassword.propTypes = {
  lenght: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  password: PropTypes.string,
  t: PropTypes.func,
  username: PropTypes.string,
};

export default withTranslation()(SecurityLevelPassword);
